<script lang="ts" setup></script>

<template>
  <section class="background">
    <div class="background__dim">
      <div class="container home">
        <div class="home__top">
          <div>내가 일하는 곳에서</div>
          <div>빠르고. 편하게. 보내고 받는</div>
          <div>똑똑한 디포스트</div>
        </div>

        <div class="home__bottom">
          <div>이용자는 수신부터, 발송까지 한 번에</div>
          <div>관리자는 운영부터, 정산까지 한 번에</div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import "@/assets/style/screens/screen.scss";

@include desktop() {
  .background {
    background: url("https://dvercorp-co-kr.imgix.net/dpost/home/main_crop.png?auto=compress")
      no-repeat;

    background-position: 0% 28%;
    background-size: cover;
  }
}
@include mobile() {
  .background {
    background: url("https://dvercorp-co-kr.imgix.net/dpost/home/main.png?auto=compress")
      no-repeat center center;

    background-size: cover;
  }
}
.background {
  &__dim {
    @apply bg-[rgba(31,31,31,0.2)];
    background-image: linear-gradient(
      to right,
      rgba(64, 77, 104, 0.6) -4%,
      rgba(238, 238, 238, 0) 20%
    );
  }
}
.home {
  @apply flex flex-col justify-center h-screen gap-6;
  @apply text-center text-white;
  @apply desktop:text-left desktop:gap-10;

  &__top {
    @apply text-2xl font-black;
    @apply desktop:text-5xl desktop:leading-[1.5];
  }
  &__bottom {
    @apply font-semibold;
    @apply desktop:text-xl desktop:leading-[1.6];
  }
}
</style>
